// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"116":"ce42fe70","453":"5b335489","732":"9988787d"}[chunkId] + ".chunk.js";
};